module.exports = __webpack_public_path__ + "media/images/lp_v6_wakatter-dbe32c19aeb2d2c784fcca069d075669.webp";